require("url-search-params-polyfill");

// If newsletter signup is submitted, detect url ?customer_posted=true
// In which case, wait til page load and scroll right down t'bottom.
// Ideally would go to, say #newsletter page position but.. rushin'
window.onload = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("customer_posted")) {
    window.scroll({
      top: 99999,
      left: 0
      // behavior: "smooth"
    });
  }
};
